import { useEffect, useState } from "react";

export default function useUnlockTimer(
  pricedAt: Date | null,
  fetchServerTimeIso: () => Promise<string | null>,
) {
  const [isLocked, setIsLocked] = useState(false);
  const [remainingTime, setRemainingTime] = useState<string | null>(null);
  const [isHour, setIsHour] = useState(false);

  useEffect(() => {
    if (!pricedAt) return () => {};

    let interval: NodeJS.Timeout | null = null;

    const initTimer = async () => {
      const serverTimeIso = await fetchServerTimeIso();
      if (!serverTimeIso) return;

      const serverTime = new Date(serverTimeIso).getTime();
      const localTime = Date.now();
      const offset = serverTime - localTime;

      const unlockTime = new Date(pricedAt).getTime();
      setIsLocked(true);

      const updateTimer = () => {
        const now = Date.now() + offset;
        const diff = Math.max(unlockTime - now, 0);

        if (diff <= 0) {
          if (interval) clearInterval(interval);
          setIsLocked(false);
          setRemainingTime(null);
          return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const formattedTime =
          hours > 0
            ? `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
            : `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

        setRemainingTime(formattedTime);
        setIsHour(hours > 0);
      };

      updateTimer();
      interval = setInterval(updateTimer, 1000);
    };

    initTimer();

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [pricedAt, fetchServerTimeIso]);

  return { isLocked, remainingTime, isHour };
}
